import { getPaginationDefaults } from "features/shared/helpers/queryParams";
import { injectable } from "inversify";
import IPaginationStateHandler from "./IPaginationStateHandler";

@injectable()
export default class PaginationStateHandler implements IPaginationStateHandler {

  getUrlParamsOfActivePagination(pageNumber: number, pageSize: number): string {
    let paginationUrlParams = getPaginationDefaults(pageSize, pageNumber);
    return paginationUrlParams.toString();
  }
}
